import React, { useEffect, useRef, useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Button, Container, Form, Input, Label, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { verifyCodeActions } from '../../../../core/sesion-verify/actions';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingIndicator from '../../../components/loading-indicator';

const ConfirmRegister = ({ register, createVerify, verifySesionCode, resetVerify }) => {
    const [verificationCode, setVerificationCode] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const nodeRef = useRef(null);
    const searchParams = new URLSearchParams(location.search);
    const tokenIdFromUrl = searchParams.get('token_id');
    const idFromState = register?.id;
    const hasVerificationTarget = Boolean(tokenIdFromUrl || idFromState);
    const [disable, setDisabled] = useState(true);
    const [animationClass, setAnimationClass] = useState({
        appearActive: 'animate__animated animate__slideInRight',
        enter: 'animate__animated',
        enterActive: 'animate__animated animate__slideInRight',
        exit: 'animate__animated',
        exitActive: 'animate__animated animate__slideOutLeft',
    })

    useEffect(() => {
        verificationCode.length > 1 && hasVerificationTarget ?
            setDisabled(false) :
            setDisabled(true)
    }, [verificationCode, hasVerificationTarget])

    useEffect(() => {
        !verifySesionCode.isNew && verifySesionCode.success &&
            navigate('/welcome')
    }, [verifySesionCode])

    useEffect(() => {
        if(!hasVerificationTarget) {
            navigate('/welcome')
        }

        return () => {
            resetVerify()
        }
    }, [hasVerificationTarget, navigate, resetVerify])

    const handleInputChange = async ({ target }) => {
        const { value } = target;
        setVerificationCode(value);
    }

    const onSubmitRegister = async (e) => {
        e.preventDefault();
        createVerify({
            code: verificationCode,
            ...(tokenIdFromUrl ? { token_id: tokenIdFromUrl } : { id: idFromState })
        })
    }

    return (
        <Container fluid="xl" className='minvh-100 overflow-hidden position-relative px-0 px-md-3'>
            <TransitionGroup component={null}>
                <CSSTransition nodeRef={nodeRef} classNames={animationClass} timeout={{ enter: 1000, exit: 1000 }} key='confirm' appear>
                    <div ref={nodeRef} className='d-flex flex-column align-items-center minvh-100'>
                        <div className="forgot-password-page register-confirm-page bg-white p-4 mt-0 my-md-auto">
                            <div className='mb-3 pt-md-3 d-flex align-items-center'>
                                <h1 className='libre-caslon-text-regular h3-md h4 mb-0'>Register</h1>
                            </div>

                            <Form onSubmit={onSubmitRegister} >
                                <FormGroup>
                                    <Label for="code">We sent a verification code to your email</Label>
                                    <Input
                                        type="text"
                                        name="verificationCode"
                                        id="code"
                                        placeholder="Please enter your verification code"
                                        value={verificationCode}
                                        onChange={handleInputChange}
                                    />
                                </FormGroup>
                                <Button color="green-light" size='sm' type="submit" disabled={disable} className='py-2 rounded-sm mb-3 btn-block'>Verify</Button>
                            </Form>

                            {!verifySesionCode.success && <p> {verifySesionCode.error} </p>}

                        </div>
                    </div>
                </CSSTransition>
            </TransitionGroup>

            {
                verifySesionCode.isPending &&
                <LoadingIndicator />
            }
        </Container>
    )
}


const mapStateToProps = (state, props) => {
    const { register, verifySesionCode } = state;
    return {
        register,
        verifySesionCode
    };
};

const mapDispatchToProps = {
    createVerify: verifyCodeActions.createVerify,
    resetVerify: verifyCodeActions.resetVerify
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfirmRegister);

